export const asyncCreateSelect = {
  option: 'async-create-option',
};
